import React, { useEffect, useState } from "react";
import "./Profile.scss";
import { Button, Card, Table } from "react-bootstrap";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import { useNavigate } from "react-router-dom";
import UserCard from "../../components/UserCard";
import { useLocalDB } from "../../contexts/LocalDBContext";

const FAKE_USER = {
  lastName: "Иванов",
  firstName: "Алексей",
  patronymic: "Сергеевич",
  phone: "+7 (900) 123-45-67",
};


const Profile = () => {
  const navigate = useNavigate();
  useBackButton("/", false, false);
  const { getAllStudios } = useLocalDB();
  const [subscriptions, setSubscriptions] = useState([]);
  
  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    patronymic: "",
    phone: "",
  });
  
  useEffect(() => {
    const stored = localStorage.getItem("userProfile");
    if (stored) {
      setFormData(JSON.parse(stored));
    } else {
      localStorage.setItem("userProfile", JSON.stringify(FAKE_USER));
      setFormData(FAKE_USER);
    }

    const loadSubs = async () => {
      const studios = await getAllStudios();
      setSubscriptions(studios.slice(0, 2)); // первые 2
    };
    loadSubs();
  }, []);

  return (
    <>
    <Header></Header>
    <SubHeader></SubHeader>
      <div className="row profile">
        <div className="col col-0 cancel col-md-3">
          <div className="return-btn" onClick={() => {navigate("/")}}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 20C0 16.2828 0 14.4241 0.307436 12.8786C1.56994 6.53151 6.53151 1.56994 12.8786 0.307436C14.4241 0 16.2828 0 20 0C23.7172 0 25.5759 0 27.1214 0.307436C33.4685 1.56994 38.4301 6.53151 39.6926 12.8786C40 14.4241 40 16.2828 40 20C40 23.7172 40 25.5759 39.6926 27.1214C38.4301 33.4685 33.4685 38.4301 27.1214 39.6926C25.5759 40 23.7172 40 20 40C16.2828 40 14.4241 40 12.8786 39.6926C6.53151 38.4301 1.56994 33.4685 0.307436 27.1214C0 25.5759 0 23.7172 0 20Z"
                fill="white" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M23.0893 14.4108C22.7638 14.0854 22.2362 14.0854 21.9108 14.4108L16.9108 19.4108C16.7545 19.5671 16.6667 19.7791 16.6667 20.0001C16.6667 20.2211 16.7545 20.4331 16.9108 20.5893L21.9108 25.5893C22.2362 25.9148 22.7638 25.9148 23.0893 25.5893C23.4147 25.2639 23.4147 24.7363 23.0893 24.4108L18.6785 20.0001L23.0893 15.5893C23.4147 15.2639 23.4147 14.7363 23.0893 14.4108Z"
                fill="#191A21" />
            </svg>
            Назад
          </div>
          
        </div>
        <div className="col col-12 col-md-9">
          <div className="card">
            <div className="row">
              <div className="col col-12">
                <div className="text-center edit-image-container">
                  <div className="image-container">
                    <img src="images/AvaBuyer.png" className="circle" />
                    <img src="images/edit-svg.svg" className="edit-image" alt="" />
                  </div>
                </div>
              </div>
              <div className="col col-12">
                <h2>Личные данные</h2>
                <div className="row">
                  <div className="col col-md-6 col-12">
                    <div className="form-floating mb-3">
                      <input type="text" placeholder="" id="floatingInputLastName" className="form-control"
                      value={formData.lastName}
                      onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                      />
                      <label for="floatingInputLastName">Фамилия</label>
                    </div>
                  </div>
                  <div className="col col-md-6 col-12">
                    <div className="form-floating mb-3">
                      <input type="text" placeholder="" id="floatingInputName" className="form-control"
                      value={formData.firstName}
                      onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                      />
                      <label for="floatingInputName">Имя</label>
                    </div>
                  </div>
                  <div className="col col-md-6 col-12">
                    <div className="form-floating mb-3">
                      <input type="text" placeholder="" id="floatingInputPatronymic" className="form-control"
                      value={formData.patronymic}
                      onChange={(e) => setFormData({ ...formData, patronymic: e.target.value })}
                      />
                      <label for="floatingInputPatronymic">Отчество</label>
                    </div>
                  </div>
                  <div className="col col-md-6 col-12">
                    <div className="form-floating mb-3">
                      <input type="text" placeholder="" id="floatingInputPhone" className="form-control"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      />
                      <label for="floatingInputPhone">Телефон</label>
                    </div>
                  </div>
                  <div className="col col-12">
                    <div onClick={() => localStorage.setItem("userProfile", JSON.stringify(formData))} className="btn btn-save">Сохранить</div>
                  </div>
                  <div className="col col-12">
                    <div
                      className="btn btn-outline-danger mt-3"
                      onClick={() => {
                        localStorage.removeItem("jwtToken");
                        window.location.reload();
                      }}
                    >
                      Выйти из аккаунта
                    </div>
                  </div>
                </div>
              </div>
              <div className="col col-12">
                <h2>Ваши подписки</h2>
                <div className="row">
                  {subscriptions.map((studio) => (
                    <div key={studio.id} className="col col-md-6 col-12">
                      <UserCard initialSubscribed={true} studioId={studio.id} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Profile;